import React from 'react';
import '../template-file-css/document-file-template.css';


export const ACTS_MstProgram = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='ACTS_MstProgram' className='file-pdf-document'>
            <div className='file-template'>


                <p className='w-750'>
                    <center><b>Mission Statement</b></center>
                </p>
                <p className='w-750'>
                    Amethyst is committed to developing and providing the latest, most effective treatment practices and, in
                    all things, promoting dignity, compassion, and respect for clients and their families as the absolute
                    standard.

                </p>
                <p className='w-750'>
                    <center><b>PROGRAM DESCRIPTION</b></center>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Multisystemic</span>

                    Multisystemic Therapy (MST) is an intensive family-and community-based treatment program that
                    focuses on the entire world of chronic and violent juvenile offenders — their homes and families, schools
                    and teachers, neighborhoods and friends. MST works with the toughest offenders. They are adolescents,
                    male and female, between the ages of 12 and 17 who have very long arrest histories. MST has 2
                    additional subdivisions, MST-SA (Substance Abuse) and MST-PSB (Problem Sexual Behavior). MST-PSB
                    program will take youth as young as 10 and as old as 17.
                    <br />
                    <br />
                    These services are intended to determine a beneficiary's treatment needs, and to provide the necessary
                    treatment. Services focus on reducing psychiatric and behavioral symptoms in order to improve the
                    beneficiary's functioning in familial, social, educational, or occupational life domains.
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Philosophy of the MST program:</span>
                </p>
                <p className='w-750'>
                    <b>Principle 1: Finding the fit</b>
                    <br />
                    An assessment is made to understand the "fit" between identified problems and how they play out and
                    make sense in the entire context of the youth's environment. Assessing the “fit” of the youth's successes
                    also helps guide the treatment process.
                </p>
                <p className='w-750'>
                    <b>Principle 2: Focusing on positives and strengths</b>
                    <br />
                    MST Therapists and team members emphasize the positives they find and use strengths in the youth's
                    world as levers for positive change. Focusing on family strengths has numerous advantages, such as
                    building on strategies the family already knows how to use, building feelings of hope, identifying
                    protective factors, decreasing frustration by emphasizing problem solving and enhancing caregivers'
                    confidence.
                </p>
                <p className='w-750'>
                    <b>Principle 3: Increasing responsibility</b>
                    <br />
                    Interventions are designed to promote responsible behavior and decrease irresponsible actions by family
                    members.
                </p>
                <p className='w-750'>
                    <b>Principle 4: Present focused, action oriented and well defined</b>
                    <br />
                    Interventions deal with what's happening now in the delinquent's life. Therapists look for action that can
                    be taken immediately, targeting specific and well-defined problems. Such interventions enable
                    participants to track the progress of the treatment and provide clear criteria to measure success. Family
                    members are expected to work actively toward goals by focusing on present-oriented solutions, versus
                    gaining insight or focusing on the past. When the clear goals are met, the treatment can end.
                </p>
                <p className='w-750'>
                    <b>Principle 5: Targeting sequences</b>
                    <br />
                    Interventions target sequences of behavior within and between the various interacting elements of the
                    adolescent's life—family, teachers, friends, home, school and community—that sustain the identified
                    problems.
                </p>
                <p className='w-750'>
                    <b>Principle 6: Developmentally appropriate</b>
                    <br />
                    Interventions are set up to be appropriate to the youth's age and fit his or her developmental needs. A
                    developmental emphasis stresses building the adolescent's ability to get along well with peers and
                    acquire academic and vocational skills that will promote a successful transition to adulthood.
                </p>
                <p className='w-750'>
                    <b>Principle 7: Continuous effort</b>
                    <br />
                    Interventions require daily or weekly effort by family members so that the youth and family have
                    frequent opportunities to demonstrate their commitment. Advantages of intensive and multifaceted
                    efforts to change include more rapid problem resolution, earlier identification of when interventions
                    need fine-tuning, continuous evaluation of outcomes, more frequent corrective interventions, more
                    opportunities for family members to experience success and giving the family power to orchestrate their
                    own changes.
                </p>
                <p className='w-750'>
                    <b>Principle 8: Evaluation and accountability</b>
                    <br />
                    Intervention effectiveness is evaluated continuously from multiple perspectives with MST team members
                    being held accountable for overcoming barriers to successful outcomes. MST does not label families as
                    “resistant, not ready for change or unmotivated.” This approach avoids blaming the family and places the
                    responsibility for positive treatment outcomes on the MST team.
                </p>
                <p className='w-750'>
                    <b>Principle 9: Generalization</b>
                    <br />
                    Interventions are designed to invest the caregivers with the ability to address the family's needs after the
                    intervention is over. The caregiver is viewed as the key to long-term success. Family members drive the
                    change process in collaboration with the MST therapist.
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Program Goals:</span>
                    The primary goals of MST treatment are to:
                    <ul>
                        <li>Eliminate or significantly reduce the frequency and severity of the youth's referral behavior(s);</li>
                        <li>Empower parents with the skills and resources needed to independently address the inevitable</li>
                    </ul>
                    difficulties that arise in raising children and adolescents, and to empower youth to cope with family,
                    peer, school, and neighborhood problems.
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Service modalities:</span>
                    We emphasize the use of evidence based practices.
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Special Populations and addressing such needs:</span>
                    Adolescents with mental health diagnosis are being served. The services that the special populations are
                    being provided are driven by their specific needs and preferences.
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Admission criteria including priority admissions:</span>
                    All admissions will be meticulously screened to ensure all requirements are being followed. Priority of
                    admissions is given to DJJDP.
                    <br />
                    <br />
                    MST providers must have the ability to deliver services in various environments, such as homes, schools,
                    detention centers and jails (state funds only), Homeless shelters, street locations, etc. Organizations that
                    provide MST must provide “first responder” crisis response on a 24/7/365 days basis to consumers who
                    are receiving this service.
                </p>


                <p className='w-750'>
                    <b>I have read and understand MST Program Description above</b>
                </p>

                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Client/Responsible Party Signature:</td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Amethyst Representative Signature:</td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                </table>



            </div>
        </form>

    )
}  
